import styled from 'styled-components';
import Text from '@text';
import styleUtils from '../../../styles/style.utils';
import themedColor from '../../../styles/theme/themed-color';
import themedFontSize from '../../../styles/theme/themed-font-size';

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${styleUtils.size('MAX_GO_BACK_CONTAINER_WIDTH')};
  padding: 0 ${styleUtils.px(16)} ${styleUtils.px(16)};
  display: flex;
  justify-content: start;
`;

const GoBackButton = styled.div`
  display: flex;
  align-items: center;
  color: ${themedColor('TEXT_DISABLED')};
  font-size: ${themedFontSize('BODY')};
  cursor: pointer;
`;

const GoBackIconContainer = styled.div`
  width: ${styleUtils.px(30)};
  height: ${styleUtils.px(30)};
  border-radius: ${styleUtils.px(15)};
  border: solid ${styleUtils.px(2)} ${themedColor('TEXT_DISABLED')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${styleUtils.px(8)};
`;

const GoBackIcon = styled.div`
  width: ${styleUtils.px(10)};
  height: ${styleUtils.px(10)};
  border-left: solid ${styleUtils.px(2)} ${themedColor('TEXT_DISABLED')};
  border-bottom: solid ${styleUtils.px(2)} ${themedColor('TEXT_DISABLED')};
  transform: rotate(45deg) translate(${styleUtils.px(1)}, ${styleUtils.px(-1)});
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    margin: 0;
    color: ${themedColor('TEXT_DISABLED')};
    font-size: ${themedFontSize('BODY')};
  }
`;

const GoBackComponents = {
  Container,
  GoBackButton,
  GoBackIconContainer,
  GoBackIcon,
  StyledText
};

export default GoBackComponents;
